import '../styles/components/Navbar.css';
import logo from '../assets/Logo2.png';

const NAV_ITEMS = [
  { key: 'home',     label: 'Home' },
  { key: 'products', label: 'Products' },
  { key: 'about',    label: 'About' },
  { key: 'presence', label: 'Global Presence' },
  { key: 'quality',  label: 'Quality' },
  { key: 'contact',  label: 'Contact Us', cta: true },
];

function Navbar({ activePage, navigate, navScrolled, mobileOpen, setMobileOpen }) {
  return (
    <>
      <nav className={`navbar ${navScrolled ? 'scrolled' : ''}`}>
        {/* Logo */}
        <div className="navbar-logo" onClick={() => navigate('home')}>
          <img src={logo} alt="Pharmchem Logo" />
        </div>

        {/* Desktop links */}
        <ul className="nav-links">
          {NAV_ITEMS.map((item) => (
            <li key={item.key}>
              <button
                className={`${activePage === item.key ? 'active' : ''} ${item.cta ? 'nav-cta' : ''}`}
                onClick={() => navigate(item.key)}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>

        {/* Hamburger */}
        <button
          className={`hamburger ${mobileOpen ? 'open' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      {/* Mobile nav overlay */}
      <div className={`mobile-nav ${mobileOpen ? 'open' : ''}`}>
        {NAV_ITEMS.map((item) => (
          <button
            key={item.key}
            onClick={() => { navigate(item.key); setMobileOpen(false); }}
          >
            {item.label}
          </button>
        ))}
      </div>
    </>
  );
}

export default Navbar;
